export default {"src":"/_next/static/media/email.195306ae.svg","height":48,"width":48};